import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { BootstrapPaginatorComponent } from "./bootstrap-paginator.component";
import { ColResizeComponent } from "./col-resize.component";
import { DataTableDirective } from "./data-table.directive";
import { DefaultSorterComponent } from "./default-sorter.component";
import { PaginatorPagesComponent } from "./paginator-pages/paginator-pages.component";
import { PaginatorRowsComponent } from "./paginator-rows/paginator-rows.component";
import { PaginatorComponent } from "./paginator.component";

@NgModule({
	imports: [
		CommonModule,
		TranslatePipe
	],
	declarations: [
		DataTableDirective,
		DefaultSorterComponent,
		PaginatorComponent,
		BootstrapPaginatorComponent,
		PaginatorRowsComponent,
		PaginatorPagesComponent,
		ColResizeComponent
	],
	exports: [
		DataTableDirective,
		DefaultSorterComponent,
		PaginatorComponent,
		BootstrapPaginatorComponent,
		PaginatorRowsComponent,
		PaginatorPagesComponent,
		ColResizeComponent
	]
})
export class DataTableModule { }